module.exports = __webpack_public_path__ + "images/bannerES-60695afdbcbb51dd98fb31a6485b9d50.png";